import PaymentDetailsList from './PaymentDetailsList';

export default {
  list: PaymentDetailsList,
};
